import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-echo-list',
  templateUrl: './echo-list.component.html',
  styleUrls: ['./echo-list.component.css']
})
export class EchoListComponent {

  @ViewChild('dt') dt: Table | undefined;

  echolist: any[] = [];
  loading: boolean = true;
  selectedSample: any;
  cols: any[] = [];

  constructor(private dataService: DataService,
    private router: Router) { }

  ngOnInit() {
    const filters = localStorage.getItem("echolist-state");
    console.log(filters);

    this.dataService.getEchoList().then(data => {
      this.echolist = data;
      this.loading = false;
    });
    this.cols = [
      { field: 'instrument', header: 'Echo Instrument' },
      { field: 'dPlate', header: 'D Plate' },
      { field: 'mmPlate', header: 'MM Plate' },
      { field: 'plvPlate', header: 'PLV Plate' },
      { field: 'aPlate', header: 'A Plate' },
      { field: 'sPlate', header: 'S Plate' },
      { field: 'startDate', header: 'Start Date' },
      //{ field: 'echoIncident', header: 'Last Echo Incident'},
      //{ field: 'echoIncidentDate', header: 'Last Echo Incident Date'},
      //{ field: 'echoService', header: 'Last Echo Service'},
      //{ field: 'echoServiceDate', header: 'Last Echo Service Date'}
    ]
  }

  clear(table: Table) {
      table.clear();
  }

  applyFilterGlobal($event:any, stringVal:any) {
    this.dt?.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  rowClick(record: any){
    //this.router.navigate(['detail',snpRecord.sampleId]);
  }
}
